// 基础数据
const basicData = {
    // 任务状态信息 -- 运输任务
    taskStatus:[
        {
            value: '0',
            label: '新建'
        }, {
            value: '1',
            label: '发布'
        }, {
            value: '2',
            label: '接单'
        }, {
            value: '3',
            label: '完成'
        }, 
        {
            value: '4',
            label: '审核'
        },{
            value: '5',
            label: '退回'
        },{
            value: '-1',
            label: '取消'
        },
    ],
    // 任务类型
    taskType:[
        {
            value: '0',
            label: '进口'
        }, {
            value: '1',
            label: '出口'
        }, {
            value: '2',
            label: '调拨'
        },{
            value: '3',
            label: '配货'
        }
    ],
    // 入库方式
    inStorageType:[
        {
            value: '0',
            label: '采购入库'
        }, {
            value: '1',
            label: '盘点入库'
        }, {
            value: '2',
            label: '其他'
        }
    ],
    // 出库方式
    outStorageType:[
        {
            value: '0',
            label: '领出'
        }, {
            value: '1',
            label: '销毁'
        }, {
            value: '2',
            label: '转出'
        }
    ],
    //叉车司机作业量作业单位
    signWorkUnitList:[
        {
            value: '吨',
            label: '吨'
        }, {
            value: '托',
            label: '托'
        }, {
            value: '张',
            label: '张'
        }, {
            value: '柜',
            label: '柜'
        }
    ],
    // 叉车司机作业量作业类型
    signWorkTypeList:[
        {
            value: '装卸',
            label: '装卸'
        }, {
            value: '上下楼',
            label: '上下楼'
        }, {
            value: '码托',
            label: '码托'
        }, {
            value: '缠膜',
            label: '缠膜'
        }, {
            value: '换标签',
            label: '换标签'
        }, {
            value: '倒货',
            label: '倒货'
        }
    ],
    // 叉车司机列表
    signWorkDriverList:[
        {
            value: '孙志军',
            label: '孙志军'
        }, {
            value: '罗文明',
            label: '罗文明'
        }, {
            value: '姚型然',
            label: '姚型然'
        }, {
            value: '青岛德盛信合建筑工程有限公司',
            label: '青岛德盛信合建筑工程有限公司'
        }, {
            value: '青岛宏瑞源货运代理有限公司',
            label: '青岛宏瑞源货运代理有限公司'
        }
    ],
    // 区外
    signWorkDriverListOut:[
        {
            value: '安曰猛',
            label: '安曰猛'
        }, {
            value: '管风星',
            label: '管风星'
        }, {
            value: '王聚军',
            label: '王聚军'
        }, {
            value: '李永亮',
            label: '李永亮'
        }, {
            value: '青岛昊鑫宇货运代理有限公司',
            label: '青岛昊鑫宇货运代理有限公司'
        }, {
            value: '青岛德盛信合建筑工程有限公司',
            label: '青岛德盛信合建筑工程有限公司'
        }, {
            value: '青岛菲凡运达供应链有限公司',
            label: '青岛菲凡运达供应链有限公司'
        }, {
            value: '青岛烨铖装卸服务有限公司',
            label: '青岛烨铖装卸服务有限公司'
        }
    ],
     // 理货员列表区内
    storekeeperList:[
        {
            name:'孙志军'
        }
    ],
    // 区外理货员
    storekeeperListOut:[
        {
            name:'朱琳'
        },{
            name:'蒋秀芬'
        },{
            name:'田晓龙'
        },{
            name:'李永亮'
        }
    ],
    // 盘点类型
    pdTypeList:[
        {
            value: '日盘',
            label: '日盘'
        }, {
            value: '周盘',
            label: '周盘'
        }, {
            value: '月盘',
            label: '月盘'
        }
    ],
}
export default basicData